import requester from '@/lib/axios';
import { QuizCreateDTO, QuizQuestion } from '@/models/Question';
import { QuizAnswer } from '@/models/Answer';
import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import {
  bannerImgConverter,
  convertToFormData,
  feedbacksConverter,
  jsonFieldConverter,
} from '@/utils/convertToFormData';

const baseUrl = 'quiz-activity';

const quizAnswersConverter = (
  key: string,
  answers: QuizAnswer[],
  formData: FormData,
) => {
  if (!answers) return;
  answers.forEach((answer, index) => {
    Object.entries(answer).forEach(([field, fieldValue]) => {
      if (fieldValue === undefined) return;
      const formKey = `${key}[${index}]${field}`;
      if (field === 'mediaFile')
        bannerImgConverter(formKey, fieldValue, formData);
      else formData.append(formKey, String(fieldValue));
    });
  });
};

const converters = {
  title: jsonFieldConverter,
  context: jsonFieldConverter,
  quizAnswers: quizAnswersConverter,
  feedbacks: feedbacksConverter,
};

export const getQuizQuestion = async (id: number) => {
  const { data: quizActivity } = await requester().get<QuizQuestion>(
    `${baseUrl}/${id}/`,
  );

  return quizActivity;
};

export const updateQuizQuestion = async (
  id: number,
  changes: Partial<
    Pick<QuizCreateDTO, 'title' | 'context' | 'quizAnswers' | 'feedbacks'>
  >,
) => {
  const formData = convertToFormData(changes, converters);

  const { data: quizActivity } = await requester().patch<QuizQuestion>(
    `${baseUrl}/${id}/`,
    formData,
    { headers },
  );

  return quizActivity;
};

export const deleteQuizQuestion = async (id: number) => {
  await requester().delete<QuizQuestion>(`${baseUrl}/${id}/`);
};

export const createQuizQuestion = async (body: Partial<QuizCreateDTO>) => {
  const formData = convertToFormData(body, converters);

  const { data: quizQuestion } = await requester().post<QuizQuestion>(
    `${baseUrl}/`,
    formData,
    { headers },
  );

  return quizQuestion;
};
